<template>
  <dialogWrap
    v-model="isShow"

    title="应付款项变更"
    :width="'824px'"
  >
    <el-form
      ref="addReceivable"
      :model="addData"
      :rules="rules"
      label-width="100px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item class="alone" :label="'应付ID' + columnSeparator">
            <p>{{ row.id }}</p>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'应付金额' + columnSeparator">
            <p>
              <span v-thousand-separator="row.payAmount"></span>
              元
            </p>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
            prop="payAmount"
            :label="`变更后金额${columnSeparator}`"
          >
            <el-input
              v-number:money
              v-model="addData.payAmount"
              clearable
              placeholder="请输入"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="'应付日期' + columnSeparator">
            <p>{{ row.payDate }}</p>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
            :label="'变更后日期' + columnSeparator"
            prop="payDate"
          >
            <el-date-picker
              v-model="addData.payDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :append-to-body="false"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            prop="remark"
            :label="'变更说明' + columnSeparator"
          >
            <el-input
              v-model="addData.remark"
              type="textarea"
              placeholder="请输入内容"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- </column-box> -->
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="cencelFn">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="submitAddCollecetion"
        v-submitDingTalkShow="23"
        >确认新增</el-button
      >
    </template>
  </dialogWrap>
</template>

<script>
import { paymentChangePayment } from '@/api/financeApi'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    show(val) {
      this.isShow = val
      for (const key in this.addData) {
        this.addData[key] = this.row[key]
      }
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
      addData: {
        payAmount: '',
        payDate: '',
        remark: '',
      },
      rules: {
        payAmount: [
          {
            required: true,
            validator: this.payAmountCheck,
            trigger: 'blur',
          },
        ],
        payDate: [
          {
            required: true,
            message: '变更后应付日期不能为空',
            trigger: 'blur',
          },
        ],
        remark: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    // 变更后金额不能小于已收金额
    payAmountCheck(rule, value, callback) {
      if (value === '') {
        callback(new Error('变更后金额不能为空'))
      } else if (Number(value) < Number(this.row.paidAmount)) {
        callback(new Error('变更后金额不能小于已付金额'))
        this.addData.payAmount = this.row.paidAmount
      }
      callback()
    },
    cencelFn() {
      this.$refs.addReceivable.resetFields()
      this.isShow = false
    },
    submitAddCollecetion() {
      this.loading = true
      const msg = this.DingTalkShow23 ? '提交审批成功' : '变更成功'
      this.$refs.addReceivable.validate((data) => {
        if (!data) return
        paymentChangePayment({
          id: this.row.id,
          ...this.addData,
        }).then((res) => {
          const { code } = res
          if (code === 1) {
            this.$message({
              message: msg,
              type: 'success',
            })
            this.isShow = false
            this.$emit('searchHandle', false)
          }
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      })
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
